/**
 * Quiz Types - Crypto Knowledge Quiz
 * Supports multilingual content (fr/en)
 */

// Localized string type
export interface LocalizedString {
  fr: string;
  en: string;
}

// Localized string array type
export interface LocalizedStringArray {
  fr: string[];
  en: string[];
}

export interface QuizQuestion {
  id: string;
  category: QuizCategory;
  difficulty: 'easy' | 'medium' | 'hard';
  question: LocalizedString;
  options: LocalizedStringArray;
  correctAnswer: number; // Index of correct option
  explanation: LocalizedString;
  articleUrl?: string;
  articleTitle?: LocalizedString;
  projectTag?: string; // e.g., 'flux', 'hedera', 'bitcoin', etc.
}

export type QuizCategory =
  | 'blockchain-basics'
  | 'defi'
  | 'staking'
  | 'trading'
  | 'security'
  | 'flux'
  | 'hedera'
  | 'bitcoin'
  | 'ethereum'
  | 'general';

export interface QuizProgress {
  totalAnswered: number;
  correctAnswers: number;
  currentStreak: number;
  bestStreak: number;
  answeredQuestions: string[]; // Question IDs
  categoryStats: Record<QuizCategory, { correct: number; total: number }>;
  lastPlayedAt?: string;
}

export interface QuizState {
  currentQuestion: QuizQuestion | null;
  selectedAnswer: number | null;
  isAnswered: boolean;
  isCorrect: boolean | null;
  showExplanation: boolean;
}

// Helper type for supported languages
export type SupportedLanguage = 'fr' | 'en';

// Helper function to get localized content
export function getLocalizedText(content: LocalizedString, lang: SupportedLanguage): string {
  return content[lang] || content.fr; // Fallback to French
}

export function getLocalizedArray(content: LocalizedStringArray, lang: SupportedLanguage): string[] {
  return content[lang] || content.fr; // Fallback to French
}
